export const COLD_START_MESSAGE =
  'Inicializando serviço, isso pode levar alguns segundos…';

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function isTimeoutError(error) {
  const code = String(error?.code || '');
  if (code === 'ECONNABORTED' || code === 'ETIMEDOUT') return true;
  const message = String(error?.message || '').toLowerCase();
  return message.includes('timeout');
}

function isNetworkError(error) {
  const code = String(error?.code || '');
  if (code === 'ERR_NETWORK') return true;
  if (code === 'ERR_CANCELED') return false;

  const message = String(error?.message || '').toLowerCase();
  if (message.includes('network error')) return true;

  return !!error?.request && !error?.response;
}

function is5xx(error) {
  const status = error?.response?.status;
  return typeof status === 'number' && status >= 500 && status < 600;
}

export function isRetryableColdStartError(error) {
  return isTimeoutError(error) || isNetworkError(error) || is5xx(error);
}

export async function requestWithColdStartRetry(
  requestFn,
  { maxRetries = 2, backoffMs = [800, 2000], onRetry } = {}
) {
  if (typeof requestFn !== 'function') {
    throw new Error('requestWithColdStartRetry: requestFn deve ser uma função');
  }

  let retries = 0;

  while (true) {
    try {
      return await requestFn();
    } catch (err) {
      if (!isRetryableColdStartError(err) || retries >= maxRetries) {
        throw err;
      }

      const delayMs = backoffMs[Math.min(retries, backoffMs.length - 1)] ?? 0;
      retries += 1;
      onRetry?.(retries, err);
      if (delayMs > 0) await sleep(delayMs);
    }
  }
}
